module.exports = __webpack_public_path__ + "static/gallery_11-thumb-544dbc4238afa2f5b35ed4e44f0a66e4.jpg";